import PropTypes from "prop-types";

import { Delete as DeleteIcon } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography } from "@mui/material";

import {
  formatMoney,
} from "../../../shared";
import { CustomTable } from "../../../ui";

const LensProductItem = ({
  index,
  lensProduct: {
    salesRequest: {
      referenceNumber,
      purchaseOrder: { note },
    },
    salesRequestProductVariants,
    price,
  },

  onDelete,
}) => {
  let addOn = null;

  // Get addOn from note
  const firstProductVariantNote =
    salesRequestProductVariants[0]?.purchaseOrderProductVariant?.note;
  if (firstProductVariantNote) {
    const parsed = JSON.parse(firstProductVariantNote);
    addOn = parsed.addOn || null;
  }

  const columns = [
    {
      field: "purchaseOrderProductVariant.side",
      headerName: "Sisi",
    },
    {
      field: "purchaseOrderProductVariant.sku",
      headerName: "SKU",
    },
  ];

  columns.push({
    field: "axis",
    headerName: "Axis",
    renderCell: ({ purchaseOrderProductVariant: { note } }) => {
      try {
        const parsed = JSON.parse(note || "{}");
        return parsed.axis ?? "-";
      } catch {
        return "-";
      }
    },
  });
  columns.push({
    field: "pd",
    headerName: "PD",
    renderCell: ({ purchaseOrderProductVariant: { note } }) => {
      try {
        const parsed = JSON.parse(note || "{}");
        return parsed.pd ?? "-";
      } catch {
        return "-";
      }
    },
  });
  columns.push({
    field: "prism",
    headerName: "Prism",
    renderCell: ({ purchaseOrderProductVariant: { note } }) => {
      try {
        const parsed = JSON.parse(note || "{}");
        return parsed.prism ?? "-";
      } catch {
        return "-";
      }
    },
  });
  // columns.push({
  //   field: "retailPrice",
  //   headerName: "@Harga",
  //   align: "right",
  //   renderCell: ({ productVariant: { retailPrice } }) =>
  //     formatMoney(retailPrice, {
  //       withCurrency: false,
  //     }),
  // });

  return (
    <Stack spacing={2}>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "space-between"
        }}>
        <Stack direction="row" sx={{
          alignItems: "center"
        }}>
          <Typography sx={{ mr: 1 }}>
            {index + 1}.{" "}
            {
              salesRequestProductVariants[0].purchaseOrderProductVariant.product
                .name
            }{" "}
            (#{referenceNumber})
          </Typography>
          {/* <IconButton onClick={onEdit}>
              <EditIcon />
            </IconButton> */}
        </Stack>
        <IconButton onClick={onDelete} color="error">
          <DeleteIcon />
        </IconButton>
      </Stack>
      <CustomTable columns={columns} rows={salesRequestProductVariants} />
      <Stack direction="row" sx={{
        justifyContent: "space-between"
      }}>
        <Typography variant="body2">
          <span style={{ color: "gray" }}>Note: </span>
          {note ?? "-"}
        </Typography>
        <Box>
          {addOn && (
            <Typography align="right" variant="body2">
              <span style={{ color: "gray" }}>Add On: </span>
              {addOn}
            </Typography>
          )}
          <Typography
            align="right"
            variant="body2"
            sx={{ fontWeight: "medium" }}
          >
            {formatMoney(price)}
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
};

export default LensProductItem;

LensProductItem.propTypes = {
  index: PropTypes.number.isRequired,
  lensProduct: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
};
